import { Typography } from '@mui/material';
import useResponsive from '@/components/hooks/useResponsive';
import { HEADLINE_TEXT_CONFIGURATIONS } from '@/components/pages/visitorHome/VisitorHomeRebrandLayout/constants';

const getHeaderCopy = (isTablet: boolean, isDesktop: boolean) => {
  const { mobile, tabletOrDesktop } = HEADLINE_TEXT_CONFIGURATIONS;
  return isTablet || isDesktop ? tabletOrDesktop : mobile;
};

const HeaderCopy = ({ text }: { text: string }) => (
  <Typography
    variant="h2"
    sx={(theme) => ({
      fontSize: {
        xs: '28px',
        sm: '36px',
        md: '48px',
      },
      lineHeight: {
        xs: '39px',
        sm: '42px',
        md: '56px',
      },
      backgroundColor: 'rgba(33, 63, 95, 0.9)',
      width: 'fit-content',
      color: 'white',
      padding: {
        xs: theme.spacing(0, 1),
        sm: `14px ${theme.spacing(3)}`,
      },
      borderRadius: '12px',
      marginBottom: {
        xs: '4px',
        sm: 1,
      },
    })}>
    {text}
  </Typography>
);

const HeroContent = () => {
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const headerCopy = getHeaderCopy(isTablet, isDesktop);

  return (
    <>
      <HeaderCopy text={headerCopy.firstLine} />
      <HeaderCopy text={headerCopy.secondLine} />

      {isMobile && <HeaderCopy text={headerCopy.thirdLine} />}
    </>
  );
};

export default HeroContent;
